module.exports = __webpack_public_path__ + "static/img/200135.3f9d19d2.png";